<h2 mat-dialog-title>{{ data?.title ?? 'Confirm finalization' }}</h2>

<div mat-dialog-content>
  <p style="margin-top: 0;">
    {{ data?.message ?? 'To finalize this DiagnosticReport, type your last name to confirm.' }}
  </p>

  <mat-form-field appearance="outline" style="width: 100%;">
    <mat-label>Last name</mat-label>
    <input matInput [formControl]="lastName" autocomplete="off" />
    <mat-hint>Must match your login profile</mat-hint>
  </mat-form-field>
</div>

<div mat-dialog-actions align="end">
  <button mat-button (click)="cancel()">Cancel</button>
  <button mat-flat-button color="primary" (click)="confirm()" [disabled]="lastName.invalid">
    Finalize
  </button>
</div>